import React, {Component} from 'react';
import {findDOMNode} from 'react-dom';
import T from 'i18n-react';
import Counter from './Counter';

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { Checkbox } from "elemental-react16";

import { Scrollbars } from 'react-custom-scrollbars';
//import ShadowScrollbars from './ShadowScrollbars';

import axios from 'axios';
import moment from "moment";

class QuickView extends Component {
    constructor(props){
        super(props);
        this.state = {
            selectedProduct: {},
            isAdded: false,
            prodImages: [],
            subscriberEmail: '',
            isSubscribed: localStorage.getItem("subscriberEmail"),
            isCheckedFlagPrivacy: false
        }
    }

    getSliderPhotos = (idProd) => {
        this.setState({ prodImages: [] });
        if (idProd === "A") {
            idProd = "54173";
        }
        let path = `products-img/${idProd}`;
        let url = '/products-list.php';
        let _self = this;
        axios.get(url, {
            params: {
                path: path
            },
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'json'
        })
            .then(function (r) {
                console.log(r);
                let prodImages = r.data.map((img) => {
                    return {
                        original: `/products-img/${idProd}/${img}`
                    }
                });
                _self.setState({ prodImages: prodImages });
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    handleClickOutside(event) {
        const domNode = findDOMNode(this.refs.modal);
        if (!domNode || !domNode.contains(event.target)) {
            this.props.closeModal();
        }
    }

    handleClose() {
        this.props.closeModal();
    }

    handleAddToCart = (image, name, price, id, idProd, quantity, available) => {
        this.setState({
            selectedProduct: {
                image: image,
                name: name,
                price: price,
                id: id,
                idProd: idProd,
                quantity: quantity,
                available: available - quantity
            }
        }, function(){
            this.props.addToCart(this.state.selectedProduct);
        });

        this.setState({
            isAdded: true
        }, function(){
            setTimeout(() => {
                this.setState({
                    isAdded: false,
                    selectedProduct: {}
                });
            }, 3750);
        });
    };

    addToCart(image, name, price, id, idProd, quantity, available){
        if (this.props.cartItems.length > 0 && this.props.cartItems.filter(x => x.id === id)[0]) {
            let existentQuantity = this.props.cartItems.filter(x => x.id === id)[0].quantity;
            let availableQuantity = this.props.cartItems.filter(x => x.id === id)[0].available;

            /*console.log('existentQuantity: ' + existentQuantity);
            console.log('quantity: ' + quantity);
            console.log('availableQuantity: ' + availableQuantity);*/

            if (quantity <= availableQuantity) {
                this.handleAddToCart(image, name, price, id, idProd, quantity, available);
            } else {
                alert(T.translate("labels.quantityNotAvailableInCart"));
            }
        } else {
            (available !== 0) ?
                this.handleAddToCart(image, name, price, id, idProd, quantity, available):
                alert(T.translate("labels.quantityNotAvailableInCart"));
        }
    }

    handleSubscriberEmail = (e) => {
        this.setState({
            email: e.target.value
        })
    };

    subscribeToNews = () => {
        if (this.state.email) {
            this.setState({
                isSubscribed: true
            }, () => {
                let subscribers = this.props.subscribersInstance.push();
                localStorage.setItem("subscriberEmail", this.state.email);
                subscribers.set({
                    "email": this.state.email,
                    "timestamp": moment().locale('it').format("YYYY-MM-DD HH:mm:ss"),
                });
            });
        }
    };

    handlePrivacyFlag = () => {
        this.setState((prevState) => {
            return {isCheckedFlagPrivacy: !prevState.isCheckedFlagPrivacy}
        })
    };

    parseNum = (num) => {
        let numFloat = num.toLocaleString(undefined, {minimumFractionDigits:2});
        return this.props.locale === 'it' ? numFloat : numFloat.replace(",", ".");
    };

    componentWillUpdate(nextProps) {
        if (nextProps) {
            if (this.props.openModal !== nextProps.openModal && nextProps.openModal === true && (nextProps.product.idProd || this.props.product.idProd)) {
                this.getSliderPhotos(nextProps.product.idProd);
            }
        } else {
            this.props.product.idProd && this.getSliderPhotos(nextProps.product.idProd);
        }
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside.bind(this), true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside.bind(this), true);
    }

    render() {
        let image = this.props.product.image;
        let name = this.props.product.name;
        let price = this.props.product.price && this.parseNum(this.props.product.price);
        let id = this.props.product.id;
        let idProd = this.props.product.idProd;
        let quantity = this.props.productQuantity;
        let description = this.props.product.description;
        let descriptionEn = this.props.product.descriptionEn;
        let available = this.props.product.available;
        let typeProduct = this.props.product.typeProduct;

        let actionButton = '',
            productTypeClass = '',
            nameStyle = '';

        if (typeProduct === 1) {
            productTypeClass = 'product-type1';
        } else if (typeProduct === 2) {
            productTypeClass = 'product-type2';
        } else {
            productTypeClass = 'product-type3';
        }

        if (id === 1) {
            nameStyle = {fontSize: 13};
        } else {
            if (name && name.length > 36) {
                nameStyle = {fontSize: 15};
            } else {
                nameStyle = {fontSize: 20};
            }
        }

        if (id !== 1) {
            if (this.props.product.available > 0) {
                actionButton = (
                    <div className="product-action">
                        <button className={!this.state.isAdded ? "" : "added"}
                                type="button"
                                disabled={this.state.isAdded}
                                onClick={this.addToCart.bind(this, image, name, price, id, idProd, quantity, available)}>
                            {!this.state.isAdded ? T.translate("labels.addToCart") : T.translate("labels.addedToCart")}</button>
                    </div>
                )
            } else {
                actionButton = (
                    <div className="product-action">
                        <button style={{backgroundColor: 'grey'}} disabled={true}>
                            {T.translate("labels.outOfStock")}
                        </button>
                    </div>
                )
            }
        } else {
            actionButton = (
                <div>
                    <hr style={{border: '1px solid #5F5895'}}/>
                    {!this.state.isSubscribed ?
                        <div>
                            <h5 style={{color: '#ffffff', fontSize: '.75em'}}>{T.translate("labels.subscribe")}</h5>
                            <input type="text"
                                   className="email-field"
                                   value={this.state.email} onChange={this.handleSubscriberEmail} /><br/>
                            <Checkbox checked={this.state.isCheckedFlagPrivacy}
                                      onClick={this.handlePrivacyFlag} style={{float: 'left', width: '4%'}} />
                            <Scrollbars style={{ width: 'calc(100% - 22px)', marginLeft: '1em', marginBottom: 7 }}
                                        autoHeight
                                        autoHeightMin={0}
                                        autoHeightMax={38}>
                                <div className="label-checkbox">
                                    {T.translate("labels.acceptPrivacyPromoProd")}
                                    <a href="http://www.bestwaycorp.it/Footer/Policy" target="_blank">{T.translate("labels.linkPrivacy")}</a>
                                    {T.translate("labels.acceptPrivacyPromoProd1")}
                                </div>
                            </Scrollbars>

                            <div style={{clear: 'both'}} />
                            <button
                                type="button"
                                onClick={this.subscribeToNews}
                                disabled={!this.state.isCheckedFlagPrivacy}>{T.translate("labels.submitAction")}</button>
                        </div> :
                        <h4 className="icon-violet">{T.translate("labels.thanksForSubscribe")}</h4>
                    }
                </div>
            )
        }

        return (
            <div className={this.props.openModal ? "modal-wrapper active" : "modal-wrapper"}>
                <div className={`modal ${productTypeClass}`} ref="modal">
                    <div className="id-product" style={nameStyle}>{name}</div>

                    <button type="button"
                            className="close"
                            onClick={this.handleClose.bind(this)}>&times;</button>
                    <div className="quick-view">
                        <div className="quick-view-image">
                            {
                                (this.state.prodImages && this.state.prodImages.length > 0) &&
                                <ImageGallery items={this.state.prodImages}
                                              showThumbnails={false}
                                              showFullscreenButton={false}
                                              showPlayButton={false}
                                              showIndex={true}
                                              defaultImage="img/preloader.gif"/>
                            }
                        </div>
                        <div className="quick-view-details" style={id === 1 ? {textAlign: 'center'} : {}}>
                            <Scrollbars style={{ width: 'auto' }}
                                        autoHeight
                                        autoHeightMin={0}
                                        autoHeightMax={92}>
                                <div className="product-desc" dangerouslySetInnerHTML={{__html: this.props.locale === 'it' ? description : descriptionEn}} />
                            </Scrollbars>
                            {(id !== 1) && <span className="product-price">{price}</span>}
                            {
                                available || available === 0 ?
                                    <p className={`product-available${available === 0 ? ' out-of-stock' : ''}`}>
                                        {available} {T.translate("labels.available")}
                                    </p> : <div />
                            }
                            {
                                id !== 1 &&
                                <Counter
                                    productAvail={available}
                                    productQuantity={quantity}
                                    updateQuantity={this.props.updateQuantity}
                                />
                            }
                            {actionButton}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default QuickView;


// WEBPACK FOOTER //
// ./src/components/QuickView.js